// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.question-container {
  position: relative;
  height: -moz-fit-content;
  height: fit-content;
  max-width: 70%;
  background-color: #fff;
  border: 1px solid #ddd;
  border-radius: 8px;
  margin: 20px 0;

  margin-top: 9%;
  padding: 15px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.triangle-isosceles:after{
  z-index: -1;
}
.question-container::before {
  content: "";
  z-index: -1;
  position: absolute;
  top: -0.6px;
  left: -17px;
  width: 25px;
  height: 40px;
  background: linear-gradient(
    255deg, #ffffff 0%, #ffffff 50%, transparent 50%, transparent
  );
  /* border-width: 10px;
  border-style: solid;
  border-color: transparent #fff transparent transparent;  */
}
.beforeul{
  margin-left: -17%;
}
.pic{
  display: flex;
  margin-right: 55px;
  margin-left: -77px;
  margin-bottom: 100px;
}
.pic1{
  display: flex;
  margin-right: 55px;
  margin-left: -77px;
  position: relative;
  opacity: 0;
  /* position: absolute; */
  /* justify-content: start; */
}
.fade-in-pic1 {
  animation: fadeIn 4s forwards;
}


.question-answerd {
  position: relative;
  height: -moz-fit-content;
  height: fit-content;
  max-width: 100%; /* Adjust the width as needed */
  background-color: #fff; /* Background color for the chat message */
  border: 1px solid #ddd; /* Border color */
  border-radius: 8px;
  margin: 20px 0;
  margin-top: 9%;
  padding: 15px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.question-answerd::before {
  content: "";
  position: absolute;
  top: -0.6px;
  left: -17px;
  width: 25px;
  height: 40px;
  background: linear-gradient(
    255deg, #ffffff 0%, #ffffff 50%, transparent 50%, transparent
  );
  /* border-width: 10px;
  border-style: solid;
  border-color: transparent #fff transparent transparent;  */
}

.answer-button {

  background-color: #00b046;
  color: #fff;
  padding: 10px;
  margin: 5px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  align-items: end;
  display: flex;
  position: relative;
  text-align: start;
  margin-left: 35%;
  width: 50%;
  /* margin-left: 40%; */
  width: 60%;
  height: -moz-fit-content;
  height: fit-content;
  /* width: ; */
  opacity: 0;
  animation: fadeIn 1s forwards;
  /* justify-content: center;  */
  align-items: center; 
  /* opacity: 0; Set initial opacity to 0
  transition: opacity 1 1s ease-in; */
}

.answered-button {
  background-color: #00b046;
    color: #fff;
    padding: 10px;
    margin: 5px;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    align-items: end;
    display: flex;
    position: relative;
    text-align: start;
    margin-left: 35%;
    width: 50%;
    height: -moz-fit-content;
    height: fit-content;
    /* justify-content: center; */
    align-items: center; 
  
  }

  .selected {
    background-color: #9bef9e;
    color: #fff;
    padding: 10px;
    margin: 5px;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    align-items: end;
    display: flex;
    position: relative;
    text-align: start;
    margin-left: 35%;
    width: 50%;
    height: -moz-fit-content;
    height: fit-content;
    align-items: center; 
  }

/* Add a class to control fading in for each button */
/* .answer-button.fade-in {
  opacity: 1;
} */
/* .answer-button span {
  
  opacity: 0;
  animation: fadeIn 3s forwards;
} */

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.answered-button {
  background-color: #00b046;
  color: #fff;
  padding: 10px;
  margin-right: 100px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  align-items: end;
  display: flex;
  position: relative;
  text-align: start;
  margin-left: 35%;
  width: 50%;
  width: 60%;
  height: -moz-fit-content;
  height: fit-content;
  /* width: ; */
  opacity: 0;
  animation: fadeIn 1s forwards;
  /* justify-content: center;  */
  align-items: center;
  /* width: fit-content; */
}

.answer-button:hover {
  background-color: #45a049;
}

.character {
  min-width: 40px;
  margin-right: 20px;
  display: flex;
  position: relative;
  justify-content: center;
 align-items: center; 
  text-align: center;
  height: -moz-fit-content;
  height: fit-content;
  font-size: x-large;
  vertical-align: middle;
  /* margin-right: 0.35em; */
}
.answer-text{
  display: flex;
  /* position: relative; */
  justify-content: start; 
  text-align: start;
  text-align-last: left;
  /* align-content: start; */
  font-size: medium;
  /* margin-left: 10px; */
  
}
.answered-questions {
  /* margin-top: 20px; */
  
}

.answered-questions p {
  /* margin-bottom: 10px; */
}

.answered-questions ul {
  /* list-style-type: none;
  padding: 0; */
}

.answered-questions li {
  /* margin-bottom: 5px;
  padding: 5px;
  border-radius: 5px; */
}
.floating-button {
  position: fixed;
  bottom: 20px;
  right: 20px;
  background-color: #ed0e55;
  color: #fff;
  padding: 20px;
  border: none;
  border-radius: 50px;
  cursor: pointer;
  display: flex;
  align-items: center;
  margin-right: 40%;
  animation: float 3s infinite ease-in-out;
}

.floating-button:hover {
  background-color: #bb2121;
}

@keyframes float {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-10px);
  }
}


.selected {
  background-color: #9bef9e;
  color: #fff;
  padding: 10px;
  margin: 5px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  align-items: end;
  display: flex;
  position: relative;
  text-align: start;
  margin-left: 35%;
  width: 60%;
  height: -moz-fit-content;
  height: fit-content;
}
.typingIndicatorContainer {
  display: flex;
  flex: none;
  align-items: flex-end;
  /* margin-top:-1000px ; */
  content: "";
  position: absolute;
  top: -40px;
  left:  -10px;
  width: 80px;
  height: 90px;
  
}

.typingIndicatorBubble {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 50px;
  margin: 0px 8px;
  background-color: #ffffff;
  border-radius: 12px;
}

.typingIndicatorBubbleDot {
  width: 4px;
  height: 4px;
  margin-right: 4px;
  background-color: #57585a;
  border-radius: 50%;
  animation-name: bounce;
  animation-duration: 1.3s;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
}

.typingIndicatorBubbleDot:first-of-type {
  margin: 0px 4px;
}

.typingIndicatorBubbleDot:nth-of-type(2) {
  animation-delay: 0.15s;
}

.typingIndicatorBubbleDot:nth-of-type(3) {
  animation-delay: 0.3s;
}
.triangle-isosceles {
  position:relative;
  padding:15px;
  margin:1em 0 3em;
  color:#000;
  background:#ffffff; /* default background for browsers without gradient support */
  /* css3 */
  background:linear-gradient(#ffffff, #ffffff);
  border-radius:10px;
  /* margin-left:50px; */
  margin-top: 90px;
  margin-left: -10px;
  background:#ffffff;
  height: -moz-fit-content;
  height: fit-content;
}
/* .triangle-isosceles {
  margin-left:50px;
  background:#f3961c;
} */
.triangle-isosceles:after {
  content:"";
  position:absolute;
  bottom:-15px; /* value = - border-top-width - border-bottom-width */
  left:50px; /* controls horizontal position */
  border-width:15px 15px 0; /* vary these values to change the angle of the vertex */
  border-style:solid;
  border-color:#ffffff transparent;
  /* reduce the damage in FF3.0 */
  display:block;
  width:0;
  top:16px; /* controls vertical position */
  left:-50px; /* value = - border-left-width - border-right-width */
  bottom:auto;
  border-width:10px 50px 10px 0;
  border-color:transparent #ffffff;
}
.allofscreen{
display: flex;
width: 80%;
margin-left: 10%;
margin-right: 10%;

/* justify-content: center;
align-items: center; */
}

@keyframes bounce {
  0%,
  60%,
  100% {
    transform: translateY(0);
  }
  30% {
    transform: translateY(-4px);
  }
}
/* The typing effect */
@keyframes typing {
  from { width: 0 }
  to { width: 100% }
}

/* The typewriter cursor effect */
@keyframes blink-caret {
  from, to { border-color: transparent }
  50% { border-color: orange; }
}
/* Media query for smaller screens */
/* @media (max-width: 576px) {
.allofscreen{
    zoom: 2;
  }
}
@media (min-width: 577px) and (max-width: 768px) {
.allofscreen{
    zoom: 1.5;
  }
} */

@media (max-width: 768px) {
  .pic1{
    margin-right: 0 !important;
  }
  .allofscreen{
    margin: 0 !important;
  }
  .answered-questions{
    
  }

  .image{
    width: 68%;
    height: 64%;
    margin-left: -98px;
    /* margin-right: px; */

    
  }
  body,html {
    overflow-x: hidden;
  }
  .triangle-isosceles {
  position: relative;
  height: -moz-fit-content;
  height: fit-content;
  max-width: 100%; /* Adjust the width as needed */
  background-color: #FFF;/* Background color for the chat message */
  border: 1px solid #FFF; /* Border color */
  border-radius: 8px;
  margin: 20px;
  margin-right: 0;
  margin-top: 50px;
  margin-left: 5px;
  /* padding: 15px; */
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.triangle-isosceles:after {
  content:"";
  position:absolute;
  bottom:-15px; /* value = - border-top-width - border-bottom-width */
  left:50px; /* controls horizontal position */
  border-width:15px 15px 0; /* vary these values to change the angle of the vertex */
  border-style:solid;
  z-index: -111;
  border-color:#FFF transparent;
  /* reduce the damage in FF3.0 */
  display:block;
  width:0;
  z-index: -1;
  top:16px; /* controls vertical position */
  left:-50px; /* value = - border-left-width - border-right-width */
  bottom:auto;
  border-width:10px 50px 10px 0;
  border-color:transparent #FFF;
}
.triangle-isosceles{
  margin: 43px 0;
}

.answered-button {
  width: 100%;
   margin-left: 0%;
  align-items: center;
  margin-right: 2% ;  
}
.selected {
  width: 100%;
  margin-left: 0%;
  align-items: center;
}

.answered-questions {
  width: 100%;
  margin-left: 0%;
 align-items: center;
  
}
.beforeul{
  /* margin-left: 50px;
  margin-right: 40px; */
  margin-left: 0%;
  width: 100%;
}
.ulanswer{
  margin-right: 0;
  /* margin-left: 41px; */
  margin: auto;
  margin-left: 9px;
  width: 92% !important;
  margin-top: 0 !important;
}
.choice{
  margin-right: 0;
  /* margin-left: 41px; */
  margin: auto;
  margin-left: 9px;
  width: 92% !important;
}
.pic{
  width: 100%;
  margin-bottom: 10px;
}
.image1,.image{
  width: 153px !important;
    height: auto !important;
    margin-left: -40px !important;
  }
  .pic,.pic1  {
    display: flex;
    width: 95% !important;
    margin-left: 0 !important;
    margin-right: 0 !important; 
}
  .answer-button {
    width: 100%;
    margin-left: 0;
    align-items: center;
    /* margin-left: 30%; */
  }
  .pic1 {
    display: flex;
    margin-right: 55px;
    margin-left: 0;
    position: relative;
  }
  .allofscreen {
    display: flex;
    width: 95%;
    padding-left: 13px;
    padding-right: 101px;
}
  .choice{
    padding-top : 100px;
    /* justify-content: center; Horizontally center */
    align-items: center;
    width: 100%;

  }
  .floating-button {
    margin-right: 30%;
  }
  .typingIndicatorContainer {
  display: flex;
  flex: none;
  align-items: flex-end;
  /* margin-top:-1000px ; */
  content: "";
  position: absolute;
  top: -42px;
  left:  -10px;
  width: 80px;
  height: 90px;
  
}

}
@media (min-width: 769px) and (max-width: 991px) {
  .allofscreen {
    /* Add styles for medium-sized screens */
    /* zoom:1.2; */
  }

  /* Add more styles as needed */
}

/* Media query for larger screens */
@media (min-width: 992px) and (max-width: 1199px) {
  .allofscreen{
    /* Add styles for larger screens */
    zoom: 1;
  }

  /* Add more styles as needed */
}

/* Media query for larger screens */
@media (min-width: 1200px) and (max-width: 1400px) {
  .question-container {
    max-width: 60%; /* Adjust the width for larger screens */
    
  }
  .beforeul{
  /* margin-left: 50px;
  margin-right: 40px; */
  /* margin-left: 0%; */
  width: 93%;
}
  .allofscreen{
    zoom: 1;
  }
}
@media (min-width: 2200px) and (max-width: 3440px) {
  .question-container {
    max-width: 60%; /* Adjust the width for larger screens */
    
  }
  .allofscreen {
    display: flex;
    width: 45%;
    margin-left: 10%;
    margin-right: 10%;
}
  .beforeul{
  /* margin-left: 50px;
  margin-right: 40px; */
  margin-left: -2%;
  width: 93%;
}
.answer-button{
  width: 40%;
}
.answered-button{
  width: 40%;
}
.selected{
  width: 40%;
}

  .allofscreen{
   
    justify-content: center;
    margin-left: 0;
    margin-right: 0;
    /* align-items: center; */
    margin: auto;

  }
}




/* Add your existing styles here */

/* Set initial opacity to 0 */
.answer-button {
  opacity: 0;

  /* Apply a fade-in animation */
  animation: fadeIn 2s ease-in-out forwards;
}

/* Define the fadeIn animation */
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Apply animation delay to each button based on its index */
.answer-button:nth-child(1) {
  animation-delay: 1s; /* 1 second delay for the first button */
}

.answer-button:nth-child(2) {
  animation-delay: 2s; /* 2 second delay for the second button */
}

.answer-button:nth-child(3) {
  animation-delay: 3s; /* 3 second delay for the third button */
}

.answer-button:nth-child(4) {
  animation-delay: 4s; /* 4 second delay for the fourth button */
}
@media (min-width:2400px) and (max-width: 3440px) {
body,html {
  overflow-x: hidden;
}
  .question-answerd {
    font-size: 2em; /* Adjust as needed */
    padding: 30px; /* Adjust as needed */
    font-size: 2.5em; 
  }

  .answer-button, .answered-button, .selected {
    font-size: 1.5em;
    padding: 20px;
    width: 100%;

    margin-left: 28%;
    font-size: 2.5em;
  }
.ulanswer{
  margin-top: 0 !important;
}
  .character {
    font-size: 28px; /* Adjust as needed */
    width: 80px; /* Adjust as needed */
    margin-right: 40px;
  }

  .answer-text {
    font-size: 28px;
  }
  .triangle-isosceles  p {

    font-size: 28px;
  }
  
  .choice{
    margin-top: 0 !important;
  }

  .triangle-isosceles {
    padding: 30px;
    border-radius: 20px;
    font-size: 26px;


    
  }

  .triangle-isosceles:after {
    border-width: 30px 30px 0; /* Adjust as needed */
    /* top: 32px; Adjust as needed */
    border-width: 20px 100px 20px 0; /* Adjust as needed */
    font-size: 2em;
  }
  
}
`, "",{"version":3,"sources":["webpack://./src/components/Question.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,wBAAmB;EAAnB,mBAAmB;EACnB,cAAc;EACd,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;;EAEd,cAAc;EACd,aAAa;EACb,wCAAwC;AAC1C;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,WAAW;EACX,YAAY;EACZ;;GAEC;EACD;;4DAE0D;AAC5D;AACA;EACE,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,wBAAwB;EACxB,4BAA4B;AAC9B;AACA;EACE,6BAA6B;AAC/B;;;AAGA;EACE,kBAAkB;EAClB,wBAAmB;EAAnB,mBAAmB;EACnB,eAAe,EAAE,+BAA+B;EAChD,sBAAsB,EAAE,0CAA0C;EAClE,sBAAsB,EAAE,iBAAiB;EACzC,kBAAkB;EAClB,cAAc;EACd,cAAc;EACd,aAAa;EACb,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,WAAW;EACX,YAAY;EACZ;;GAEC;EACD;;4DAE0D;AAC5D;;AAEA;;EAEE,yBAAyB;EACzB,WAAW;EACX,aAAa;EACb,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,UAAU;EACV,sBAAsB;EACtB,UAAU;EACV,wBAAmB;EAAnB,mBAAmB;EACnB,aAAa;EACb,UAAU;EACV,6BAA6B;EAC7B,8BAA8B;EAC9B,mBAAmB;EACnB;qCACmC;AACrC;;AAEA;EACE,yBAAyB;IACvB,WAAW;IACX,aAAa;IACb,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,UAAU;IACV,wBAAmB;IAAnB,mBAAmB;IACnB,6BAA6B;IAC7B,mBAAmB;;EAErB;;EAEA;IACE,yBAAyB;IACzB,WAAW;IACX,aAAa;IACb,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,UAAU;IACV,wBAAmB;IAAnB,mBAAmB;IACnB,mBAAmB;EACrB;;AAEF,qDAAqD;AACrD;;GAEG;AACH;;;;GAIG;;AAEH;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,UAAU;EACV,UAAU;EACV,wBAAmB;EAAnB,mBAAmB;EACnB,aAAa;EACb,UAAU;EACV,6BAA6B;EAC7B,8BAA8B;EAC9B,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,uBAAuB;CACxB,mBAAmB;EAClB,kBAAkB;EAClB,wBAAmB;EAAnB,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;EACtB,0BAA0B;AAC5B;AACA;EACE,aAAa;EACb,wBAAwB;EACxB,sBAAsB;EACtB,iBAAiB;EACjB,qBAAqB;EACrB,0BAA0B;EAC1B,iBAAiB;EACjB,uBAAuB;;AAEzB;AACA;EACE,sBAAsB;;AAExB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;eACa;AACf;;AAEA;EACE;;uBAEqB;AACvB;AACA;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,WAAW;EACX,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,4BAA4B;EAC9B;AACF;;;AAGA;EACE,yBAAyB;EACzB,WAAW;EACX,aAAa;EACb,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,UAAU;EACV,wBAAmB;EAAnB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,UAAU;EACV,qBAAqB;EACrB,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,WAAW;EACX,YAAY;;AAEd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;EACtB,wBAAwB;EACxB,iCAAiC;EACjC,mCAAmC;AACrC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;AACA;EACE,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,kBAAkB,EAAE,6DAA6D;EACjF,SAAS;EAIT,4CAA4C;EAG5C,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,wBAAmB;EAAnB,mBAAmB;AACrB;AACA;;;GAGG;AACH;EACE,UAAU;EACV,iBAAiB;EACjB,YAAY,EAAE,qDAAqD;EACnE,SAAS,EAAE,iCAAiC;EAC5C,wBAAwB,EAAE,wDAAwD;EAClF,kBAAkB;EAClB,gCAAgC;EAChC,+BAA+B;EAC/B,aAAa;EACb,OAAO;EACP,QAAQ,EAAE,+BAA+B;EACzC,UAAU,EAAE,qDAAqD;EACjE,WAAW;EACX,6BAA6B;EAC7B,gCAAgC;AAClC;AACA;AACA,aAAa;AACb,UAAU;AACV,gBAAgB;AAChB,iBAAiB;;AAEjB;sBACsB;AACtB;;AAEA;EACE;;;IAGE,wBAAwB;EAC1B;EACA;IACE,2BAA2B;EAC7B;AACF;AACA,sBAAsB;AACtB;EACE,OAAO,SAAS;EAChB,KAAK,YAAY;AACnB;;AAEA,iCAAiC;AACjC;EACE,WAAW,0BAA0B;EACrC,MAAM,oBAAoB,EAAE;AAC9B;AACA,oCAAoC;AACpC;;;;;;;;;GASG;;AAEH;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,oBAAoB;EACtB;EACA;;EAEA;;EAEA;IACE,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,sBAAsB;;;EAGxB;EACA;IACE,kBAAkB;EACpB;EACA;EACA,kBAAkB;EAClB,wBAAmB;EAAnB,mBAAmB;EACnB,eAAe,EAAE,+BAA+B;EAChD,sBAAsB,CAAC,0CAA0C;EACjE,sBAAsB,EAAE,iBAAiB;EACzC,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,wCAAwC;AAC1C;AACA;EACE,UAAU;EACV,iBAAiB;EACjB,YAAY,EAAE,qDAAqD;EACnE,SAAS,EAAE,iCAAiC;EAC5C,wBAAwB,EAAE,wDAAwD;EAClF,kBAAkB;EAClB,aAAa;EACb,6BAA6B;EAC7B,+BAA+B;EAC/B,aAAa;EACb,OAAO;EACP,WAAW;EACX,QAAQ,EAAE,+BAA+B;EACzC,UAAU,EAAE,qDAAqD;EACjE,WAAW;EACX,6BAA6B;EAC7B,6BAA6B;AAC/B;AACA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;GACV,eAAe;EAChB,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;CAChB,mBAAmB;;AAEpB;AACA;EACE;uBACqB;EACrB,eAAe;EACf,WAAW;AACb;AACA;EACE,eAAe;EACf,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,qBAAqB;EACrB,wBAAwB;AAC1B;AACA;EACE,eAAe;EACf,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,uBAAuB;IACrB,uBAAuB;IACvB,6BAA6B;EAC/B;EACA;IACE,aAAa;IACb,qBAAqB;IACrB,yBAAyB;IACzB,0BAA0B;AAC9B;EACE;IACE,WAAW;IACX,cAAc;IACd,mBAAmB;IACnB,sBAAsB;EACxB;EACA;IACE,aAAa;IACb,kBAAkB;IAClB,cAAc;IACd,kBAAkB;EACpB;EACA;IACE,aAAa;IACb,UAAU;IACV,kBAAkB;IAClB,oBAAoB;AACxB;EACE;IACE,mBAAmB;IACnB,iDAAiD;IACjD,mBAAmB;IACnB,WAAW;;EAEb;EACA;IACE,iBAAiB;EACnB;EACA;EACA,aAAa;EACb,UAAU;EACV,qBAAqB;EACrB,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,WAAW;EACX,YAAY;;AAEd;;AAEA;AACA;EACE;IACE,wCAAwC;IACxC,cAAc;EAChB;;EAEA,8BAA8B;AAChC;;AAEA,mCAAmC;AACnC;EACE;IACE,kCAAkC;IAClC,OAAO;EACT;;EAEA,8BAA8B;AAChC;;AAEA,mCAAmC;AACnC;EACE;IACE,cAAc,EAAE,wCAAwC;;EAE1D;EACA;EACA;uBACqB;EACrB,qBAAqB;EACrB,UAAU;AACZ;EACE;IACE,OAAO;EACT;AACF;AACA;EACE;IACE,cAAc,EAAE,wCAAwC;;EAE1D;EACA;IACE,aAAa;IACb,UAAU;IACV,gBAAgB;IAChB,iBAAiB;AACrB;EACE;EACA;uBACqB;EACrB,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;;EAEE;;IAEE,uBAAuB;IACvB,cAAc;IACd,eAAe;IACf,yBAAyB;IACzB,YAAY;;EAEd;AACF;;;;;AAKA,kCAAkC;;AAElC,6BAA6B;AAC7B;EACE,UAAU;;EAEV,8BAA8B;EAC9B,yCAAyC;AAC3C;;AAEA,gCAAgC;AAChC;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA,4DAA4D;AAC5D;EACE,mBAAmB,EAAE,wCAAwC;AAC/D;;AAEA;EACE,mBAAmB,EAAE,yCAAyC;AAChE;;AAEA;EACE,mBAAmB,EAAE,wCAAwC;AAC/D;;AAEA;EACE,mBAAmB,EAAE,yCAAyC;AAChE;AACA;AACA;EACE,kBAAkB;AACpB;EACE;IACE,cAAc,EAAE,qBAAqB;IACrC,aAAa,EAAE,qBAAqB;IACpC,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,aAAa;IACb,WAAW;;IAEX,gBAAgB;IAChB,gBAAgB;EAClB;AACF;EACE,wBAAwB;AAC1B;EACE;IACE,eAAe,EAAE,qBAAqB;IACtC,WAAW,EAAE,qBAAqB;IAClC,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;EACA;;IAEE,eAAe;EACjB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,eAAe;;;;EAIjB;;EAEA;IACE,yBAAyB,EAAE,qBAAqB;IAChD,gCAAgC;IAChC,+BAA+B,EAAE,qBAAqB;IACtD,cAAc;EAChB;;AAEF","sourcesContent":[".question-container {\n  position: relative;\n  height: fit-content;\n  max-width: 70%;\n  background-color: #fff;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  margin: 20px 0;\n\n  margin-top: 9%;\n  padding: 15px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n.triangle-isosceles:after{\n  z-index: -1;\n}\n.question-container::before {\n  content: \"\";\n  z-index: -1;\n  position: absolute;\n  top: -0.6px;\n  left: -17px;\n  width: 25px;\n  height: 40px;\n  background: linear-gradient(\n    255deg, #ffffff 0%, #ffffff 50%, transparent 50%, transparent\n  );\n  /* border-width: 10px;\n  border-style: solid;\n  border-color: transparent #fff transparent transparent;  */\n}\n.beforeul{\n  margin-left: -17%;\n}\n.pic{\n  display: flex;\n  margin-right: 55px;\n  margin-left: -77px;\n  margin-bottom: 100px;\n}\n.pic1{\n  display: flex;\n  margin-right: 55px;\n  margin-left: -77px;\n  position: relative;\n  opacity: 0;\n  /* position: absolute; */\n  /* justify-content: start; */\n}\n.fade-in-pic1 {\n  animation: fadeIn 4s forwards;\n}\n\n\n.question-answerd {\n  position: relative;\n  height: fit-content;\n  max-width: 100%; /* Adjust the width as needed */\n  background-color: #fff; /* Background color for the chat message */\n  border: 1px solid #ddd; /* Border color */\n  border-radius: 8px;\n  margin: 20px 0;\n  margin-top: 9%;\n  padding: 15px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.question-answerd::before {\n  content: \"\";\n  position: absolute;\n  top: -0.6px;\n  left: -17px;\n  width: 25px;\n  height: 40px;\n  background: linear-gradient(\n    255deg, #ffffff 0%, #ffffff 50%, transparent 50%, transparent\n  );\n  /* border-width: 10px;\n  border-style: solid;\n  border-color: transparent #fff transparent transparent;  */\n}\n\n.answer-button {\n\n  background-color: #00b046;\n  color: #fff;\n  padding: 10px;\n  margin: 5px;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  align-items: end;\n  display: flex;\n  position: relative;\n  text-align: start;\n  margin-left: 35%;\n  width: 50%;\n  /* margin-left: 40%; */\n  width: 60%;\n  height: fit-content;\n  /* width: ; */\n  opacity: 0;\n  animation: fadeIn 1s forwards;\n  /* justify-content: center;  */\n  align-items: center; \n  /* opacity: 0; Set initial opacity to 0\n  transition: opacity 1 1s ease-in; */\n}\n\n.answered-button {\n  background-color: #00b046;\n    color: #fff;\n    padding: 10px;\n    margin: 5px;\n    border: none;\n    border-radius: 5px;\n    cursor: pointer;\n    align-items: end;\n    display: flex;\n    position: relative;\n    text-align: start;\n    margin-left: 35%;\n    width: 50%;\n    height: fit-content;\n    /* justify-content: center; */\n    align-items: center; \n  \n  }\n\n  .selected {\n    background-color: #9bef9e;\n    color: #fff;\n    padding: 10px;\n    margin: 5px;\n    border: none;\n    border-radius: 5px;\n    cursor: pointer;\n    align-items: end;\n    display: flex;\n    position: relative;\n    text-align: start;\n    margin-left: 35%;\n    width: 50%;\n    height: fit-content;\n    align-items: center; \n  }\n\n/* Add a class to control fading in for each button */\n/* .answer-button.fade-in {\n  opacity: 1;\n} */\n/* .answer-button span {\n  \n  opacity: 0;\n  animation: fadeIn 3s forwards;\n} */\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n.answered-button {\n  background-color: #00b046;\n  color: #fff;\n  padding: 10px;\n  margin-right: 100px;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  align-items: end;\n  display: flex;\n  position: relative;\n  text-align: start;\n  margin-left: 35%;\n  width: 50%;\n  width: 60%;\n  height: fit-content;\n  /* width: ; */\n  opacity: 0;\n  animation: fadeIn 1s forwards;\n  /* justify-content: center;  */\n  align-items: center;\n  /* width: fit-content; */\n}\n\n.answer-button:hover {\n  background-color: #45a049;\n}\n\n.character {\n  min-width: 40px;\n  margin-right: 20px;\n  display: flex;\n  position: relative;\n  justify-content: center;\n align-items: center; \n  text-align: center;\n  height: fit-content;\n  font-size: x-large;\n  vertical-align: middle;\n  /* margin-right: 0.35em; */\n}\n.answer-text{\n  display: flex;\n  /* position: relative; */\n  justify-content: start; \n  text-align: start;\n  text-align-last: left;\n  /* align-content: start; */\n  font-size: medium;\n  /* margin-left: 10px; */\n  \n}\n.answered-questions {\n  /* margin-top: 20px; */\n  \n}\n\n.answered-questions p {\n  /* margin-bottom: 10px; */\n}\n\n.answered-questions ul {\n  /* list-style-type: none;\n  padding: 0; */\n}\n\n.answered-questions li {\n  /* margin-bottom: 5px;\n  padding: 5px;\n  border-radius: 5px; */\n}\n.floating-button {\n  position: fixed;\n  bottom: 20px;\n  right: 20px;\n  background-color: #ed0e55;\n  color: #fff;\n  padding: 20px;\n  border: none;\n  border-radius: 50px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  margin-right: 40%;\n  animation: float 3s infinite ease-in-out;\n}\n\n.floating-button:hover {\n  background-color: #bb2121;\n}\n\n@keyframes float {\n  0%, 100% {\n    transform: translateY(0);\n  }\n  50% {\n    transform: translateY(-10px);\n  }\n}\n\n\n.selected {\n  background-color: #9bef9e;\n  color: #fff;\n  padding: 10px;\n  margin: 5px;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  align-items: end;\n  display: flex;\n  position: relative;\n  text-align: start;\n  margin-left: 35%;\n  width: 60%;\n  height: fit-content;\n}\n.typingIndicatorContainer {\n  display: flex;\n  flex: none;\n  align-items: flex-end;\n  /* margin-top:-1000px ; */\n  content: \"\";\n  position: absolute;\n  top: -40px;\n  left:  -10px;\n  width: 80px;\n  height: 90px;\n  \n}\n\n.typingIndicatorBubble {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 60px;\n  height: 50px;\n  margin: 0px 8px;\n  background-color: #ffffff;\n  border-radius: 12px;\n}\n\n.typingIndicatorBubbleDot {\n  width: 4px;\n  height: 4px;\n  margin-right: 4px;\n  background-color: #57585a;\n  border-radius: 50%;\n  animation-name: bounce;\n  animation-duration: 1.3s;\n  animation-timing-function: linear;\n  animation-iteration-count: infinite;\n}\n\n.typingIndicatorBubbleDot:first-of-type {\n  margin: 0px 4px;\n}\n\n.typingIndicatorBubbleDot:nth-of-type(2) {\n  animation-delay: 0.15s;\n}\n\n.typingIndicatorBubbleDot:nth-of-type(3) {\n  animation-delay: 0.3s;\n}\n.triangle-isosceles {\n  position:relative;\n  padding:15px;\n  margin:1em 0 3em;\n  color:#000;\n  background:#ffffff; /* default background for browsers without gradient support */\n  /* css3 */\n  background:-webkit-gradient(linear, 0 0, 0 100%, from(#ffffff), to(#ffffff));\n  background:-moz-linear-gradient(#ffffff, #ffffff);\n  background:-o-linear-gradient(#ffffff, #ffffff);\n  background:linear-gradient(#ffffff, #ffffff);\n  -webkit-border-radius:10px;\n  -moz-border-radius:10px;\n  border-radius:10px;\n  /* margin-left:50px; */\n  margin-top: 90px;\n  margin-left: -10px;\n  background:#ffffff;\n  height: fit-content;\n}\n/* .triangle-isosceles {\n  margin-left:50px;\n  background:#f3961c;\n} */\n.triangle-isosceles:after {\n  content:\"\";\n  position:absolute;\n  bottom:-15px; /* value = - border-top-width - border-bottom-width */\n  left:50px; /* controls horizontal position */\n  border-width:15px 15px 0; /* vary these values to change the angle of the vertex */\n  border-style:solid;\n  border-color:#ffffff transparent;\n  /* reduce the damage in FF3.0 */\n  display:block;\n  width:0;\n  top:16px; /* controls vertical position */\n  left:-50px; /* value = - border-left-width - border-right-width */\n  bottom:auto;\n  border-width:10px 50px 10px 0;\n  border-color:transparent #ffffff;\n}\n.allofscreen{\ndisplay: flex;\nwidth: 80%;\nmargin-left: 10%;\nmargin-right: 10%;\n\n/* justify-content: center;\nalign-items: center; */\n}\n\n@keyframes bounce {\n  0%,\n  60%,\n  100% {\n    transform: translateY(0);\n  }\n  30% {\n    transform: translateY(-4px);\n  }\n}\n/* The typing effect */\n@keyframes typing {\n  from { width: 0 }\n  to { width: 100% }\n}\n\n/* The typewriter cursor effect */\n@keyframes blink-caret {\n  from, to { border-color: transparent }\n  50% { border-color: orange; }\n}\n/* Media query for smaller screens */\n/* @media (max-width: 576px) {\n.allofscreen{\n    zoom: 2;\n  }\n}\n@media (min-width: 577px) and (max-width: 768px) {\n.allofscreen{\n    zoom: 1.5;\n  }\n} */\n\n@media (max-width: 768px) {\n  .pic1{\n    margin-right: 0 !important;\n  }\n  .allofscreen{\n    margin: 0 !important;\n  }\n  .answered-questions{\n    \n  }\n\n  .image{\n    width: 68%;\n    height: 64%;\n    margin-left: -98px;\n    /* margin-right: px; */\n\n    \n  }\n  body,html {\n    overflow-x: hidden;\n  }\n  .triangle-isosceles {\n  position: relative;\n  height: fit-content;\n  max-width: 100%; /* Adjust the width as needed */\n  background-color: #FFF;/* Background color for the chat message */\n  border: 1px solid #FFF; /* Border color */\n  border-radius: 8px;\n  margin: 20px;\n  margin-right: 0;\n  margin-top: 50px;\n  margin-left: 5px;\n  /* padding: 15px; */\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n.triangle-isosceles:after {\n  content:\"\";\n  position:absolute;\n  bottom:-15px; /* value = - border-top-width - border-bottom-width */\n  left:50px; /* controls horizontal position */\n  border-width:15px 15px 0; /* vary these values to change the angle of the vertex */\n  border-style:solid;\n  z-index: -111;\n  border-color:#FFF transparent;\n  /* reduce the damage in FF3.0 */\n  display:block;\n  width:0;\n  z-index: -1;\n  top:16px; /* controls vertical position */\n  left:-50px; /* value = - border-left-width - border-right-width */\n  bottom:auto;\n  border-width:10px 50px 10px 0;\n  border-color:transparent #FFF;\n}\n.triangle-isosceles{\n  margin: 43px 0;\n}\n\n.answered-button {\n  width: 100%;\n   margin-left: 0%;\n  align-items: center;\n  margin-right: 2% ;  \n}\n.selected {\n  width: 100%;\n  margin-left: 0%;\n  align-items: center;\n}\n\n.answered-questions {\n  width: 100%;\n  margin-left: 0%;\n align-items: center;\n  \n}\n.beforeul{\n  /* margin-left: 50px;\n  margin-right: 40px; */\n  margin-left: 0%;\n  width: 100%;\n}\n.ulanswer{\n  margin-right: 0;\n  /* margin-left: 41px; */\n  margin: auto;\n  margin-left: 9px;\n  width: 92% !important;\n  margin-top: 0 !important;\n}\n.choice{\n  margin-right: 0;\n  /* margin-left: 41px; */\n  margin: auto;\n  margin-left: 9px;\n  width: 92% !important;\n}\n.pic{\n  width: 100%;\n  margin-bottom: 10px;\n}\n.image1,.image{\n  width: 153px !important;\n    height: auto !important;\n    margin-left: -40px !important;\n  }\n  .pic,.pic1  {\n    display: flex;\n    width: 95% !important;\n    margin-left: 0 !important;\n    margin-right: 0 !important; \n}\n  .answer-button {\n    width: 100%;\n    margin-left: 0;\n    align-items: center;\n    /* margin-left: 30%; */\n  }\n  .pic1 {\n    display: flex;\n    margin-right: 55px;\n    margin-left: 0;\n    position: relative;\n  }\n  .allofscreen {\n    display: flex;\n    width: 95%;\n    padding-left: 13px;\n    padding-right: 101px;\n}\n  .choice{\n    padding-top : 100px;\n    /* justify-content: center; Horizontally center */\n    align-items: center;\n    width: 100%;\n\n  }\n  .floating-button {\n    margin-right: 30%;\n  }\n  .typingIndicatorContainer {\n  display: flex;\n  flex: none;\n  align-items: flex-end;\n  /* margin-top:-1000px ; */\n  content: \"\";\n  position: absolute;\n  top: -42px;\n  left:  -10px;\n  width: 80px;\n  height: 90px;\n  \n}\n\n}\n@media (min-width: 769px) and (max-width: 991px) {\n  .allofscreen {\n    /* Add styles for medium-sized screens */\n    /* zoom:1.2; */\n  }\n\n  /* Add more styles as needed */\n}\n\n/* Media query for larger screens */\n@media (min-width: 992px) and (max-width: 1199px) {\n  .allofscreen{\n    /* Add styles for larger screens */\n    zoom: 1;\n  }\n\n  /* Add more styles as needed */\n}\n\n/* Media query for larger screens */\n@media (min-width: 1200px) and (max-width: 1400px) {\n  .question-container {\n    max-width: 60%; /* Adjust the width for larger screens */\n    \n  }\n  .beforeul{\n  /* margin-left: 50px;\n  margin-right: 40px; */\n  /* margin-left: 0%; */\n  width: 93%;\n}\n  .allofscreen{\n    zoom: 1;\n  }\n}\n@media (min-width: 2200px) and (max-width: 3440px) {\n  .question-container {\n    max-width: 60%; /* Adjust the width for larger screens */\n    \n  }\n  .allofscreen {\n    display: flex;\n    width: 45%;\n    margin-left: 10%;\n    margin-right: 10%;\n}\n  .beforeul{\n  /* margin-left: 50px;\n  margin-right: 40px; */\n  margin-left: -2%;\n  width: 93%;\n}\n.answer-button{\n  width: 40%;\n}\n.answered-button{\n  width: 40%;\n}\n.selected{\n  width: 40%;\n}\n\n  .allofscreen{\n   \n    justify-content: center;\n    margin-left: 0;\n    margin-right: 0;\n    /* align-items: center; */\n    margin: auto;\n\n  }\n}\n\n\n\n\n/* Add your existing styles here */\n\n/* Set initial opacity to 0 */\n.answer-button {\n  opacity: 0;\n\n  /* Apply a fade-in animation */\n  animation: fadeIn 2s ease-in-out forwards;\n}\n\n/* Define the fadeIn animation */\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n/* Apply animation delay to each button based on its index */\n.answer-button:nth-child(1) {\n  animation-delay: 1s; /* 1 second delay for the first button */\n}\n\n.answer-button:nth-child(2) {\n  animation-delay: 2s; /* 2 second delay for the second button */\n}\n\n.answer-button:nth-child(3) {\n  animation-delay: 3s; /* 3 second delay for the third button */\n}\n\n.answer-button:nth-child(4) {\n  animation-delay: 4s; /* 4 second delay for the fourth button */\n}\n@media (min-width:2400px) and (max-width: 3440px) {\nbody,html {\n  overflow-x: hidden;\n}\n  .question-answerd {\n    font-size: 2em; /* Adjust as needed */\n    padding: 30px; /* Adjust as needed */\n    font-size: 2.5em; \n  }\n\n  .answer-button, .answered-button, .selected {\n    font-size: 1.5em;\n    padding: 20px;\n    width: 100%;\n\n    margin-left: 28%;\n    font-size: 2.5em;\n  }\n.ulanswer{\n  margin-top: 0 !important;\n}\n  .character {\n    font-size: 28px; /* Adjust as needed */\n    width: 80px; /* Adjust as needed */\n    margin-right: 40px;\n  }\n\n  .answer-text {\n    font-size: 28px;\n  }\n  .triangle-isosceles  p {\n\n    font-size: 28px;\n  }\n  \n  .choice{\n    margin-top: 0 !important;\n  }\n\n  .triangle-isosceles {\n    padding: 30px;\n    border-radius: 20px;\n    font-size: 26px;\n\n\n    \n  }\n\n  .triangle-isosceles:after {\n    border-width: 30px 30px 0; /* Adjust as needed */\n    /* top: 32px; Adjust as needed */\n    border-width: 20px 100px 20px 0; /* Adjust as needed */\n    font-size: 2em;\n  }\n  \n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
